import { motion } from "framer-motion";
import type { IconKind, IconProps } from "../../icon";
import { Icon } from "../../icon";
import { cn } from "../../lib/utils";
import { DotLoader } from "../../loaders";

export interface ToolAvatarProps {
	icon: IconKind;
	iconSize?: IconProps["size"];
	className?: string;
	badgeClassName?: string;
	isLoading?: boolean;
	isDone?: boolean;
	isCanceled?: boolean;
}

export function ToolAvatar({
	className,
	badgeClassName,
	icon,
	iconSize = "xs",
	isLoading,
	isDone,
	isCanceled,
}: ToolAvatarProps): React.ReactElement {
	return (
		<div
			className={cn(
				"h-9 w-9",
				"flex items-center justify-center",
				"flex-shrink-0 flex-grow-0",
				"rounded-full",
				"relative",
				"bg-message-avatar-background",
				className,
			)}
		>
			{isLoading ? (
				<DotLoader dotClassName="bg-surface-inverted" />
			) : (
				<Icon kind={icon} size={iconSize} />
			)}

			{isCanceled ? (
				<motion.div
					animate={{ scale: 1 }}
					className={cn(
						"-bottom-1 -right-1 absolute",
						"rounded-full",
						badgeClassName,
					)}
					initial={{ scale: 0 }}
				>
					<Icon kind="cancel" size="sm" />
				</motion.div>
			) : null}

			{isDone ? (
				<motion.div
					animate={{ scale: 1 }}
					className={cn(
						"-bottom-1 -right-1 absolute",
						"rounded-full",
						badgeClassName,
					)}
					initial={{ scale: 0 }}
				>
					<Icon kind="done-filled" size="sm" />
				</motion.div>
			) : null}
		</div>
	);
}
